module.exports = __webpack_public_path__ + "pcph/img/mother-1.7fcf8003.jpg";